// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-f6882120]{margin:5px 0;display:flex;align-items:center}.icon[data-v-f6882120]{font-size:16px}.text[data-v-f6882120]{font-size:14px;line-height:18px;margin:0 15px 0 8px}.change-button[data-v-f6882120]{padding:2px 12px;border:1px solid #c8d4db;box-sizing:border-box;border-radius:22px;color:#6c7d87;font-size:11px;line-height:15px;margin-left:15px}", ""]);
// Exports
module.exports = exports;
